import React, { useRef } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';

interface MediaUploadElementProps {
  accept?: string;
  previewURL?: string | null;
  allowedTypes?: string[];
  onSelect: (file: File | null) => void;
  onRemove: () => void;
}

const MediaUploadElement: React.FC<MediaUploadElementProps> = ({
  accept = 'image/*',
  allowedTypes = ['jpg', 'jpeg', 'png'],
  previewURL,
  onSelect,
  onRemove,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onHandleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file: File | null = event.target.files && event.target.files[0];
    if (!file) {
      onSelect(null);
      return;
    }
    onSelect(file);
  };

  const handleRemoveImage = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onSelect(null);
    onRemove();
  };
  return (
    <Stack>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: 120,
          border: '1px solid #ccc',
          borderRadius: 1,
          overflow: 'hidden',
        }}
      >
        <input
          ref={inputRef}
          accept={accept}
          type="file"
          style={{ display: 'none' }}
          onChange={onHandleFileInput}
        />
        <IconButton
          size="small"
          onClick={handleRemoveImage}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            bgcolor: 'background.paper',
          }}
          aria-label="remove"
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
        <Box
          onClick={() => inputRef.current?.click()}
          sx={{
            background: previewURL ? `url('${previewURL}')` : '#f0f0f0',
            backgroundSize: 'auto',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <PhotoCamera />
        </Box>
      </Box>
      <Typography variant="body2">{`Allowed Types: ${allowedTypes.join(',')}`}</Typography>
    </Stack>
  );
};

export default MediaUploadElement;
